// import React, { useContext, useState, useRef, useEffect } from 'react';
// import style from './Today.module.css';
// import icons from '../../../icons';
// import { AppContext } from '../../../AppContext';

// import Chart from '../Chart/Chart';
// import Events from './Events/Events';
// import Banner from '../../Banner/Banner';

// import IconButton from '../../Buttons/IconButton/IconButton';
// import { Swiper, SwiperSlide } from 'swiper/react';
// import 'swiper/swiper-bundle.css';


// const prettifyDate = strDate => {
//     if (String(strDate).length === 1) return `0${strDate}`;
//     return strDate;
// };

// const addDays = (date, days) => {
//     let newDate = new Date(date.valueOf());
//     newDate.setDate(newDate.getDate() + days);
//     return newDate;
// };

// const Today = props => {
//     const { user, tests, interrogations, homeworks, others, timetable, subjects, setPage } = useContext(AppContext);

//     const [selected, setSelected] = useState(null);
//     const [events, setEvents] = useState(null);
//     // const [date, setDate] = useState(new Date(2022, 8, 9));
//     const [date, setDate] = useState(new Date());
//     const [swiperActiveSlide, setSwiperActiveSlide] = useState((new Date()).getDay());

//     const main = useRef();
//     const swiper = useRef();

//     const compareDates = (firstDate, secondDate, strict=false) => {
//         if (!firstDate || !secondDate) 
//             return false;

//         if (strict)
//             return firstDate.getTime() === secondDate.getTime();
        
//         return firstDate.getDate() === secondDate.getDate() && firstDate.getMonth() === secondDate.getMonth() && firstDate.getFullYear() === secondDate.getFullYear();
//     };

//     const dateInPeriod = (start, date, end) => {
//         if (!start || !date || !end)
//             return false;

//         return start.getTime() < date.getTime() && date.getTime() < end.getTime();
//     };

//     const eventsDone = type => {
//         const events = { tests, interrogations, homeworks, others };
//         if (!events[type])
//             return [0, 0];

//         let count = 0;
//         Object.values(events[type]).forEach(event => {
//             if (event.done[user.id])
//                 count += 1
//         });

//         const eventActive = event => event.startDate ? (dateInPeriod(new Date(event.startDate), date, new Date(event.endDate))) : compareDates(date, new Date(event.date));

//         return [count, Object.values(events[type]).filter(eventActive).length];
//     };
    
//     const getItalianWeekDay = weekDay => {
//         switch (weekDay) {
//             case 0:
//                 return "Domenica";
//             case 1:
//                 return "Lunedì";
//             case 2:
//                 return "Martedì";
//             case 3:
//                 return "Mercoledì";
//             case 4:
//                 return "Giovedì";
//             case 5:
//                 return "Venerdì";
//             case 6:
//                 return "Sabato";
//         }
//     };

//     const getSubjectIcon = subjectName => {
//         let returnIcon = "question_mark_orange_icon";
//         if (subjects)
//             Object.values(subjects).forEach(subject => {
//                 if (subject.subject.toLowerCase() === subjectName?.toLowerCase()) returnIcon = subject.icon;
//             });

//         return returnIcon;
//     };
    
//     const getEvents = () => {
//         const events = { tests, interrogations, homeworks, others }, toReturn = {};
        
//         const getTypeEvents = type => {
//             const typeEvents = {};

//             if (!events[type])
//                 return;

//             Object.values(events[type]).forEach(event => {
//                 switch (type) {
//                     case "interrogations":
//                         if (dateInPeriod(new Date(event.startDate), date, new Date(event.endDate)))
//                             typeEvents[event.id] = event;
//                     default:
//                         if (compareDates(date, new Date(event.date)))
//                             typeEvents[event.id] = event;
//                 }
//             });

//             return typeEvents;
//         }

//         toReturn["tests"] = getTypeEvents("tests");
//         toReturn["interrogations"] = getTypeEvents("interrogations");
//         toReturn["homeworks"] = getTypeEvents("homeworks");
//         toReturn["others"] = getTypeEvents("others");

//         return toReturn;
//     };

//     const getLessonEvents = subject => {
//         if (!events)
//             return [];
            
//         const toReturn = [];
//         Object.values(events).forEach(typeEvents => {
//             if (typeEvents)
//                 Object.values(typeEvents).forEach(event => {
//                     if (event.subject === subject.subjectTitle && isEventInLesson(event, subject))
//                         toReturn.push(event);
//                 });
//         });

//         return toReturn;
//     };

//     const getEventsWithoutLesson = () => {
//         const toReturn = [];
//         const dateSubjects = Object.values(timetable?.[date.getDay()] ?? []).map(lesson => lesson.subjectTitle);

//         if (!events)
//             return [];

//         Object.values(events).forEach(typeEvents => {
//             if (typeEvents)
//                 Object.values(typeEvents).forEach(event => {
//                     if (!dateSubjects.includes(event.subject) && !event.replaceLesson)
//                         toReturn.push(event);
//                 });
//         });

//         return toReturn;
//     };

//     const getReplacementEvents = () => {
//         const toReturn = {};
//         if (!events)
//             return [];

//         Object.values(events).forEach(typeEvents => {
//             Object.values(typeEvents).forEach(event => {
//                 if (event.replaceLesson) {
//                     if (event.startDate)
//                         toReturn[`${prettifyDate((new Date(event.startDate)).getUTCHours())}:${prettifyDate((new Date(event.startDate)).getUTCMinutes())}`] = event;
//                     else
//                         toReturn[`${prettifyDate((new Date(event.date)).getUTCHours())}:${prettifyDate((new Date(event.date)).getUTCMinutes())}`] = event;
//                 }
//             });
//         });

//         return toReturn;
//     };

//     const openEvents = (subject, lesson) => {
//         if (getLessonEvents(subject).length === 0 && lesson !== "others" && Object.keys(getReplacementEvents(lesson.startTime)).length === 0) {
//             setPage({ page: "add", event: { subject, date } })
//             return;
//         }

//         main.current.scrollIntoView({ behavior: "smooth" });
//         setSelected(lesson);
//     };

//     const isEventInLesson = (event, lesson) => {
//         const eventDate = new Date(event.date ?? event.startDate);
//         const eventStartTime = `${prettifyDate(eventDate.getUTCHours())}:${prettifyDate(eventDate.getUTCMinutes())}`;
//         const dayTimetable = timetable?.[date.getDay()];
//         if (!dayTimetable)
//             return true;

//         return event.type === "interrogation" || 
//             eventStartTime === lesson.startTime || 
//             Object.keys(dayTimetable).indexOf(eventStartTime) <= Object.keys(dayTimetable).indexOf(lesson.startTime) && Object.keys(dayTimetable).indexOf(lesson.startTime) < Object.keys(dayTimetable).indexOf(eventStartTime) + parseInt(event.duration);
//     };

//     const getWeekDays = () => {
//         let startDate = new Date(date);
//         while (startDate.getDay() !== 1)
//             startDate = addDays(startDate, -1);

//         const dates = [startDate];
//         while (startDate.getDay() !== 0) {
//             startDate = addDays(startDate, 1);
//             dates.push(startDate);
//         }

//         return dates;
//     }

//     useEffect(() => {
//         props.setViewingClass(selected !== null);
//     }, [selected]);

//     useEffect(() => {
//         setEvents(getEvents());
//     }, [tests, interrogations, homeworks, others]);

//     useEffect(() => {
//         if (!timetable?.[date.getDay()])
//             return;

//         const endTime = Object.values(timetable[date.getDay()])[Object.keys(timetable[date.getDay()]).length - 1]?.endTime;
//         if (!endTime)
//             return;

//         if (parseInt(endTime.split(":")[0]) < (new Date()).getHours() || (parseInt(endTime.split(":")[0]) === (new Date().getHours()) && parseInt(endTime.split(":")[1]) < (new Date()).getMinutes()))
//             setSwiperActiveSlide((addDays(date, 1)).getDay());
//     }, [timetable]);

//     useEffect(() => {
//         swiper.current.swiper.slideTo(swiperActiveSlide);
//         setDate(getWeekDays()[swiperActiveSlide]);
//     }, [swiperActiveSlide]);

//     return <main className={ style.main } ref={ main } style={{ height: selected !== null ? "100vh" : "100%" }}>
//         <Banner />
//         <h3 className={ style.sectionHeader } style={{ marginBottom: "0" }}>Completati</h3>
//         <section className={ style.progessStatus }>
//             <div className={ style.chart }>
//                 <Chart progress={ parseInt((eventsDone('tests')[0] / eventsDone('tests')[1]) * 100) } color="#FF0000" aspectRatio={ 1.1 } />
//                 <Chart progress={ parseInt((eventsDone('interrogations')[0] / eventsDone('interrogations')[1]) * 100) } color="#ddd900" top=".8rem" aspectRatio={ 1.3 } />
//                 <Chart progress={ parseInt((eventsDone('homeworks')[0] / eventsDone('homeworks')[1]) * 100) } color="#d86c07" top="1.5rem" aspectRatio={ 1.55 } />
//                 <Chart progress={ parseInt((eventsDone('others')[0] / eventsDone('others')[1]) * 100) } color="#00FFFB" top="2.1rem" aspectRatio={ 1.9 } />
//             </div>
//             <div className={ style.chartLegend }>
//                 <div className={ style.legendItem }>
//                     <div className={ style.legendItemHeader }>                        
//                         <span className={ style.legendItemIndicator } style={{ backgroundColor: "#FF0000" }}></span>
//                         <h4 className={ style.legendItemText }>Scritti</h4>
//                     </div>
//                     <h5 className={ style.legendItemProgress }>{ eventsDone('tests')[0] } su { eventsDone('tests')[1] }</h5>
//                 </div>
//                 <div className={ style.legendItem }>
//                     <div className={ style.legendItemHeader }>                        
//                         <span className={ style.legendItemIndicator } style={{ backgroundColor: "#ddd900" }}></span>
//                         <h4 className={ style.legendItemText }>Orali</h4>
//                     </div>
//                     <h5 className={ style.legendItemProgress }>{ eventsDone('interrogations')[0] } su { eventsDone('interrogations')[1] }</h5>
//                 </div>
//                 <div className={ style.legendItem }>
//                     <div className={ style.legendItemHeader }>                        
//                         <span className={ style.legendItemIndicator } style={{ backgroundColor: "#d86c07" }}></span>
//                         <h4 className={ style.legendItemText }>Per casa</h4>
//                     </div>
//                     <h5 className={ style.legendItemProgress }>{ eventsDone('homeworks')[0] } su { eventsDone('homeworks')[1] }</h5>
//                 </div>
//                 <div className={ style.legendItem }>
//                     <div className={ style.legendItemHeader }>                        
//                         <span className={ style.legendItemIndicator } style={{ backgroundColor: "#00FFFB" }}></span>
//                         <h4 className={ style.legendItemText }>Altro</h4>
//                     </div>
//                     <h5 className={ style.legendItemProgress }>{ eventsDone('others')[0] } su { eventsDone('others')[1] }</h5>
//                 </div>
//             </div>
//         </section>
//         <div className={ style.daySelect }>
//             { getWeekDays().map((weekDay, index) => <div key={ `weekDay-${weekDay.getDay()}` } className={ [style.dayOption, date.getDate() === weekDay.getDate() && style.selected].join(" ") } onClick={ () => setSwiperActiveSlide(index) }>
//                 <h4 className={ style.dayOptionWeekDay }>{ getItalianWeekDay(weekDay.getDay())[0] }</h4>
//                 <h4 className={ style.dayOptionDate }>{ weekDay.getDate() }</h4>
//             </div>) }
//         </div>
//         {/* <h3 className={ style.sectionHeader }>{ getItalianWeekDay(date.getDay())} {date.getDate() }</h3> */}
//         <Swiper ref={ swiper } onSlideChange={ ({ activeIndex }) => setSwiperActiveSlide(activeIndex) } style={{ position: selected !== null && "absolute", top: selected && "0", transition: "all .5 ease" }}>
//             { getWeekDays().map((weekDay, index) => <SwiperSlide key={ `weekDaySlide-${weekDay.getDay()}` }>
//                 { (timetable?.[weekDay.getDay()] && Object.keys(timetable?.[weekDay.getDay()]).length > 0) ? <section className={ style.timetable }>
//                     <div className={ style.progress }>
//                         { getEventsWithoutLesson().length > 0 && <span key={ `progress-others` } style={{ marginBottom: "4rem" }} className={ [style.classIndicator, style.last, !getEventsWithoutLesson().find(event => !event.done?.[user.id]) && style.done].join(" ") }>
//                             { !getEventsWithoutLesson().find(event => !event.done?.[user.id]) && <img src={ icons.check_icon }></img> }
//                         </span> }
//                         { Object.keys(timetable[weekDay.getDay()]).map((startTime, index) => {
//                             const lastElement = Object.keys(timetable[weekDay.getDay()]).length - 1 === index;
//                             const [hour, minute] = startTime.split(":");
//                             const done = weekDay.getHours() > parseInt(hour) || (weekDay.getHours() === parseInt(hour) && weekDay.getMinutes() > parseInt(minute));

//                             return <span key={ `progress-${index}` } className={ [style.classIndicator, lastElement && style.last, done && style.done].join(" ") }>
//                                 { done && <img src={ icons.check_icon }></img> }
//                             </span>; 
//                         }) }
//                     </div>
//                     <div className={ style.content }>
//                         { getEventsWithoutLesson().length > 0 && <div className={ style.class } onClick={ () => openEvents("Altro", "others") }>
//                             <section className={ style.classHeader }>
//                                 <img className={ style.subjectIcon } src={ icons.question_mark_orange_icon }></img>
//                                 <h4 className={ style.subject }>Altro</h4>
//                             </section>
//                             <section className={ style.classBottom }>
//                                 <h3 className={ style.eventsCount }><span>{ getEventsWithoutLesson().length }</span> eventi</h3>
//                                 <img src={ icons.clock_orange_icon }></img>
//                                 <h5 className={ style.time }>??:?? - ??:??</h5>
//                             </section>
//                             <Events
//                                 mainContent={ props.mainContent } 
//                                 selected={ selected === "others" }
//                                 lesson={{ subjectTitle: "Altro", subjectIcon: icons.question_mark_orange_icon }}
//                                 date={ weekDay }
//                                 events={ getEventsWithoutLesson() }
//                                 hide={ e => {
//                                     e.stopPropagation();
//                                     setSelected(null);
//                                 } } 
//                             />
//                         </div> }
//                         { Object.values(timetable[weekDay.getDay()]).map((lesson, index) => {
//                             const replacementEvent = getReplacementEvents()[lesson.startTime];
//                             return <div key={ `lesson-${index}` } className={ style.class } onClick={ () => openEvents(lesson, lesson.startTime) }>
//                                 <section className={ style.classHeader }>
//                                     <img className={ style.subjectIcon } src={ icons[getSubjectIcon(replacementEvent?.subject ?? lesson.subjectTitle)] }></img>
//                                     <h4 className={ style.subject }>{ replacementEvent?.subject ?? lesson.subjectTitle }</h4>
//                                 </section>
//                                 <section className={ style.classBottom }>
//                                     <h3 className={ style.eventsCount }><span>{ replacementEvent ? 1 : getLessonEvents(lesson).length }</span> eventi</h3>
//                                     <img src={ icons.clock_orange_icon }></img>
//                                     <h5 className={ style.time }>{ lesson.startTime } - { lesson.endTime }</h5>
//                                 </section>
//                                 <Events
//                                     mainContent={ props.mainContent } 
//                                     selected={ selected === lesson.startTime }
//                                     lesson={ replacementEvent ? { ...lesson, subjectTitle: replacementEvent.subject, icon: getSubjectIcon(replacementEvent.subject) } : lesson }
//                                     date={ weekDay }
//                                     events={ replacementEvent ? [replacementEvent] : getLessonEvents(lesson) }
//                                     hide={ e => {
//                                         e.stopPropagation();
//                                         setSelected(null);
//                                     } } 
//                                 />
//                             </div>
//                         }) }
//                     </div>
//                 </section> :
//                 <div className={ style.noTimetable }>
//                     { (subjects && Object.keys(subjects).length > 0) ? <>
//                         <h3 className={ style.noTimetableHeader }>Non hai nessuna lezione!</h3>
//                         <IconButton text="VAI ALL'ORARIO" icon={ icons.clock_icon } style={{ marginTop: "2rem", padding: ".5rem 0", marginBottom: "2rem" }} onClick={ () => setPage({ page: "menu", menuPage: "timetable", from: "home", timetableDay: index }) } />
//                     </> : 
//                     <>
//                         <h3 className={ style.noTimetableHeader }>Non hai nessuna lezione!</h3>
//                         <IconButton text="VAI ALLE MATERIE" icon={ icons.sync_icon } style={{ marginTop: "2rem", padding: ".5rem 0", marginBottom: "2rem" }} onClick={ () => setPage({ page: "menu", menuPage: "subjects", from: "home" }) } />                
//                     </> }
//                 </div> }
//             </SwiperSlide>) }
//         </Swiper>
//     </main>;
// };

// export default Today;


import React, { useContext, useState, useRef, useEffect } from 'react';
import style from './Today.module.css';
import icons from '../../../icons';
import { AppContext } from '../../../AppContext';

import Events from './Events/Events';
import Banner from '../../Banner/Banner';
import IconButton from '../../Buttons/IconButton/IconButton';

import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper-bundle.css';
import Checkbox from '../../Checkbox/Checkbox';
import { doc, updateDoc } from 'firebase/firestore';
import { db } from '../../../firebase';

import { CircularProgressbar, CircularProgressbarWithChildren , buildStyles } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';

import { Reorder } from "framer-motion";


const prettifyDate = strDate => {
    if (String(strDate).length === 1) return `0${strDate}`;
    return strDate;
};

const addDays = (date, days) => {
    let newDate = new Date(date.valueOf());
    newDate.setDate(newDate.getDate() + days);
    return newDate;
};

let sectionsTouchInterval;
const dateFormatter = new Intl.DateTimeFormat("it-IT", {
    weekday: "long",
    day: "numeric",
    month: "numeric",
});

const literalGrades = [
    "0", "0+", "0½", "1-",
    "1", "1+", "1½", "2-",
    "2", "2+", "2½", "3-",
    "3", "3+", "3½", "4-",
    "4", "4+", "4½", "5-",
    "5", "5+", "5½", "6-",
    "6", "6+", "6½", "7-",
    "7", "7+", "7½", "8-",
    "8", "8+", "8½", "9-",
    "9", "9+", "9½", "10-",
    "10", "10+"
];

const numericGrades = [
    0, 0.3, 0.5, 0.8,
    1, 1.3, 1.5, 1.8,
    2, 2.3, 2.5, 2.8,
    3, 3.3, 3.5, 3.8,
    4, 4.3, 4.5, 4.8,
    5, 5.3, 5.5, 5.8,
    6, 6.3, 6.5, 6.8,
    7, 7.3, 7.5, 7.8,
    8, 8.3, 8.5, 8.8,
    9, 9.3, 9.5, 9.8,
    10, 10

];

const Today = props => {
    const { data, schoolUsers, user, tests, setTests, interrogations, setInterrogations, homeworks, setHomeworks, others, setOthers, timetable, subjects, announcements, classPresidents, schoolPresidents, setPage, hideNavBar, showNavBar, sectionsOrder, updateSectionOrder: setSectionsOrder, editingSectionsOrder, setEditingSectionsOrder } = useContext(AppContext);

    const [selected, setSelected] = useState(null);
    const [date, setDate] = useState(new Date());
    const [swiperActiveSlide, setSwiperActiveSlide] = useState((new Date()).getDay() === 0 ? 6 : (new Date()).getDay() - 1);
    const [average, setAverage] = useState(0);
    const [grades, setGrades] = useState([]);
    const [lastGrade, setLastGrade] = useState([]);

    const main = useRef();
    const swiper = useRef();

    const compareDates = (firstDate, secondDate, strict=false) => {
        if (!firstDate || !secondDate) 
            return false;

        if (strict)
            return firstDate.getTime() === secondDate.getTime();
        
        return firstDate.getDate() === secondDate.getDate() && firstDate.getMonth() === secondDate.getMonth() && firstDate.getFullYear() === secondDate.getFullYear();
    };

    const dateInPeriod = (start, date, end) => {
        if (!start || !date || !end)
            return false;
            
        return (compareDates(start, date) || start.getTime() < date.getTime()) && date.getTime() < end.getTime();
    };
    
    const dateBefore = (firstDate, secondDate, strict=false) => {
        if (strict)
            return firstDate.getTime() < secondDate.getTime();

        return (
            (firstDate.getFullYear() < secondDate.getFullYear()) ||
            (firstDate.getFullYear() === secondDate.getFullYear() && firstDate.getMonth() < secondDate.getMonth()) ||
            (firstDate.getFullYear() === secondDate.getFullYear() && firstDate.getMonth() === secondDate.getMonth() && firstDate.getDate() < secondDate.getDate()) ||
            (firstDate.getFullYear() === secondDate.getFullYear() && firstDate.getMonth() === secondDate.getMonth() && firstDate.getDate() === secondDate.getDate() && firstDate.getHours() < secondDate.getUTCHours()) ||
            (firstDate.getFullYear() === secondDate.getFullYear() && firstDate.getMonth() === secondDate.getMonth() && firstDate.getDate() === secondDate.getDate() && firstDate.getHours() === secondDate.getUTCHours() && firstDate.getMinutes() < secondDate.getUTCMinutes())
        );
    };

    const eventsDone = (type, day=new Date()) => {
        const events = { tests, interrogations, homeworks, others };
        if (!events[type])
            return [0, 0];

        let count = 0;
        // const eventActive = event => event.startDate ? (dateInPeriod(new Date(event.startDate), date, new Date(event.endDate))) : compareDates(date, new Date(event.date));
        const eventActive = event => event.startDate ? (dateInPeriod(new Date(event.startDate), day, new Date(event.endDate))) : dateBefore(day, new Date(event.date));
        
        Object.values(events[type]).forEach(event => {
            if (event.done[user.id] && eventActive(event))
                count += 1
        });

        return [count, Object.values(events[type]).filter(eventActive).length];
    };
    
    const getItalianWeekDay = weekDay => {
        switch (weekDay) {
            case 0:
                return "Domenica";
            case 1:
                return "Lunedì";
            case 2:
                return "Martedì";
            case 3:
                return "Mercoledì";
            case 4:
                return "Giovedì";
            case 5:
                return "Venerdì";
            case 6:
                return "Sabato";
        }
    };

    const getTypeIcon = eventType => {
        switch (eventType) {
            case "test":
                return icons.test_icon;
            case "interrogation":
                return icons.interrogation_icon;
            case "homework":
                return icons.home_orange_icon;
            default:
                return icons.question_mark_orange_icon;
        }
    };

    const getItalianType = eventType => {
        switch (eventType) {
            case "test":
                return "Verifica";
            case "interrogation":
                return "Orale";
            case "homework":
                return "Per casa";
            case "other":
                return "Altro";
            default:
                return "Scegli";
        }
    };

    const getSubjectIcon = subjectName => {
        let returnIcon = "question_mark_orange_icon";
        if (subjects)
            Object.values(subjects).forEach(subject => {
                if (subject.subject.toLowerCase() === subjectName?.toLowerCase()) returnIcon = subject.icon;
            });

        return returnIcon;
    };
    
    const getEvents = day => {
        const events = { tests, interrogations, homeworks, others };
        
        const getTypeEvents = type => {
            const typeEvents = {};

            if (!events[type])
                return;

            Object.values(events[type]).forEach(event => {
                switch (type) {
                    case "interrogations":
                        if (dateInPeriod(new Date(event.startDate), day, new Date(event.endDate)))
                            typeEvents[event.id] = event;
                    default:
                        if (compareDates(day, new Date(event.date)))
                            typeEvents[event.id] = event;
                }
            });

            return typeEvents;
        };

        return { ...getTypeEvents("tests"), ...getTypeEvents("interrogations"), ...getTypeEvents("homeworks"), ...getTypeEvents("others") };
    };

    const getLessonEvents = (day, lesson) => {
        const events = getEvents(day);
        if (!events || Object.keys(events).length === 0 || !timetable || Object.keys(timetable).length === 0 || !lesson)
            return [];

        const isEventInLesson = event => {
            const eventDate = new Date(event.date ?? event.startDate);
            const eventStartTime = `${prettifyDate(eventDate.getUTCHours())}:${prettifyDate(eventDate.getUTCMinutes())}`;
            const dayTimetable = timetable[day.getDay()];

            if (event.subject !== lesson.subjectTitle)
                return false;

            if (event.type === "interrogation")
                return true;

            return lesson.startTime === eventStartTime || (Object.keys(dayTimetable).indexOf(eventStartTime) <= Object.keys(dayTimetable).indexOf(lesson.startTime) && Object.keys(dayTimetable).indexOf(lesson.startTime) < Object.keys(dayTimetable).indexOf(eventStartTime) + parseInt(event.duration));
        };
        
        return Object.values(events).filter(isEventInLesson);
    };

    const getEventsWithoutLesson = day => {
        const events = getEvents(day);
        if (!events || !timetable)
            return [];

        const toReturn = [];
        const dateSubjects = Object.values(timetable?.[date.getDay()] ?? []).map(lesson => lesson.subjectTitle);

        Object.values(events).forEach(event => {
            if (!dateSubjects.includes(event.subject) && !event.replaceLesson && event.type !== "interrogation")
                toReturn.push(event);
        });

        return toReturn;
    };

    const getReplacementEvents = day => {
        const toReturn = {};
        const events = getEvents(day);
        if (!events)
            return {};

        Object.values(events).forEach(event => {
            if (event.replaceLesson) {
                if (event.startDate)
                    toReturn[`${prettifyDate((new Date(event.startDate)).getUTCHours())}:${prettifyDate((new Date(event.startDate)).getUTCMinutes())}`] = event;
                else
                    toReturn[`${prettifyDate((new Date(event.date)).getUTCHours())}:${prettifyDate((new Date(event.date)).getUTCMinutes())}`] = event;
            }
        });

        return toReturn;
    };

    const getUpcomingEvents = () => {
        const events = { tests, interrogations, homeworks, others };
        const toReturn = [];
        const today = new Date();

        Object.keys(events).forEach(type => {
            Object.values(events[type]).forEach(event => {
                switch (type) {
                    case "interrogations":
                        if (
                            (dateInPeriod(new Date(event.startDate), today, new Date(event.endDate)) || 
                            dateInPeriod(new Date(event.startDate), addDays(today, 1), new Date(event.endDate)) || 
                            dateInPeriod(new Date(event.startDate), addDays(today, 2), new Date(event.endDate)) || 
                            dateInPeriod(new Date(event.startDate), addDays(today, 3), new Date(event.endDate)) || 
                            dateInPeriod(new Date(event.startDate), addDays(today, 4), new Date(event.endDate)) || 
                            dateInPeriod(new Date(event.startDate), addDays(today, 5), new Date(event.endDate)) || 
                            dateInPeriod(new Date(event.startDate), addDays(today, 6), new Date(event.endDate))) && 
                            !event.done?.[user?.id]
                        )
                        toReturn.push(event);
                    default:
                        if (dateInPeriod(today, new Date(event.date), addDays(today, 7)) && !event.done?.[user?.id])
                            toReturn.push(event);
                }
            });
        })

        return toReturn.sort((first, second) => new Date(first.date ?? first.startDate) - new Date(second.date ?? second.startDate));
    }

    const openEvents = (day, lesson, notInTimetable=false) => {
        if (((!notInTimetable && getLessonEvents(day, lesson).length === 0) || (notInTimetable && (getEventsWithoutLesson(day)).length === 0)) && Object.keys(getReplacementEvents(day)[lesson.startTime] ?? {}).length === 0) {
            setPage({ page: "add", event: { subject: lesson.subjectTitle, date: day } })
            return;
        }

        main.current.scrollTo(0, 0);
        // main.current.scrollIntoView({ behavior: "smooth" });
        setSelected(lesson);
    };

    const getWeekDays = () => {
        let startDate = new Date(date);
        while (startDate.getDay() !== 1)
            startDate = addDays(startDate, -1);

        const dates = [startDate];
        while (startDate.getDay() !== 0) {
            startDate = addDays(startDate, 1);
            dates.push(startDate);
        }

        return dates;
    };

    const moveSection = (section, up) => {
        const oldPosition = sectionsOrder.today.indexOf(section);
        console.log(up, oldPosition === sectionsOrder.today.length - 1, oldPosition, sectionsOrder.today.length - 1, !up && oldPosition === sectionsOrder.today.length - 1)
        if ((up && oldPosition === 0) || (!up && oldPosition === sectionsOrder.today.length - 1))
            return;

        const newOrder = [ ...sectionsOrder.today ];
                                
        const newPosition = up ? oldPosition - 1 : oldPosition + 1;
        const oldSection = sectionsOrder.today[newPosition];

        newOrder[newPosition] = section;
        newOrder[oldPosition] = oldSection;
        
        localStorage.setItem("globalSectionsOrder", JSON.stringify({ ...sectionsOrder, today: newOrder }))
        setSectionsOrder({ today: newOrder });
    };

    const setChecked = async (event, done) => {
        if (!user)
            return false;

        const updateEvent = () => {
            const setState = event.type === "test" ? setTests : event.type === "interrogation" ? setInterrogations : event.type === "homework" ? setHomeworks : setOthers;
            setState(oldState => ({
                ...oldState,
                [event.id]: {
                    ...event,
                    done: {
                        ...event.done,
                        [user.id]: done
                    }
                }
            }));
        };

        updateEvent(event.type);
        await updateDoc(doc(db, `schools/${user?.school}/classes/${user?.class}/${event.type}s/`, event.id), { [`done.${user.id}`]: done });
    };

    useEffect(() => {
        props.setViewingClass?.(selected !== null);
    }, [selected]);

    useEffect(() => {
        if (!props.loading && timetable?.[date.getDay()]) {
            const endTime = Object.values(timetable[date.getDay()])[Object.keys(timetable[date.getDay()]).length - 1]?.endTime;

            if (endTime && parseInt(endTime.split(":")[0]) < (new Date()).getHours() || (parseInt(endTime.split(":")[0]) === (new Date().getHours()) && parseInt(endTime.split(":")[1]) < (new Date()).getMinutes()))
                setTimeout(() => {
                    const newDate = addDays(date, 1);
                    setDate(newDate);
                    setSwiperActiveSlide(newDate.getDay() === 0 ? 6 : newDate.getDay() - 1);
                }, 1);
        }
    }, [timetable, props.loading]);

    useEffect(() => {
        if (!props.loading) {
            swiper.current.swiper.slideTo(swiperActiveSlide);
            setDate(getWeekDays()[swiperActiveSlide]);
        }
    }, [swiperActiveSlide, props.loading]);

    useEffect(() => {
        if (!props.loading) {
            const getEvents = eventsType => Object.values(eventsType ?? []).sort((first, second) => new Date(first.date ?? first.startDate) - new Date(second.date ?? second.startDate));
            let gradesSum = 0, counter = 0, events = [...getEvents(tests), ...getEvents(interrogations), ...getEvents(homeworks), ...getEvents(others)];

            events.forEach(event => {
                if (event.grades?.[user?.id]?.grade != undefined && event.grades?.[user?.id].inGradeAverage && event.grades?.[user?.id].inGradeAverage && Number(new Date(event.startDate ?? event.date).getTime() >= new Date(data.calendar.termsSeparator).getTime()) === Number(new Date().getTime() >= new Date(data.calendar.termsSeparator).getTime())) {
                    gradesSum += parseFloat(event.grades?.[user?.id]?.grade);
                    counter += 1;
                }
            });
            
            setLastGrade(events.filter(event => event.grades?.[user?.id]?.grade != undefined && event.grades?.[user?.id].inGradeAverage).sort((first, second) => new Date(second.date ?? second.startDate).getTime() - new Date(first.date ?? first.startDate))?.[0]);
            setGrades(events.filter(event => event.grades?.[user?.id]?.grade != undefined && event.grades?.[user?.id].inGradeAverage).map(event => event.grades?.[user?.id]?.grade));
            setAverage(gradesSum / counter);
        }
    }, [tests, interrogations, interrogations, others, user, props.loading, data]);

    useEffect(() => {
        if (editingSectionsOrder) hideNavBar();
        else showNavBar();
    }, [editingSectionsOrder])

    const getPageSection = section => {
        switch (section) {
            case "charts":
                return <section key="charts" className={ [style.pageSection, editingSectionsOrder && style.editingSectionsOrder].join(" ") } onTouchStart={ e => {
                    sectionsTouchInterval = setInterval(() => setEditingSectionsOrder(true), 500)
                    e.stopPropagation();
                } }  onTouchMove={ () => clearInterval(sectionsTouchInterval) } onTouchEnd={ () => clearInterval(sectionsTouchInterval) }>
                    <div className={ style.flex } >
                        <h3 className={ style.sectionHeader } style={{ marginBottom: "0" }}>I tuoi voti</h3> 
                        { editingSectionsOrder && <div className={ style.editSectionOrder }>
                            <img src={ icons.arrow_up_icon } style={{ width: "2rem", height: "2rem" }} onClick={ e => {
                                e.stopPropagation();
                                moveSection(section, true);
                            } }></img>
                            <img src={ icons.arrow_down_icon } style={{ width: "2rem", height: "2rem" }} onClick={ e => {
                                e.stopPropagation();
                                moveSection(section, false);
                            } }></img>
                        </div> }
                    </div>
                    <section className={ style.progessStatus } style={{ maxWidth: "100vw" }}>
                        <div className={ style.flex } style={{ paddingLeft: "1rem", paddingRight: "1rem", paddingBottom: "0" }}>
                            <div style={{ flex: "1", marginRight: "1rem" }}>
                                <h5 style={{ marginTop: "0",  textAlign: "center", fontSize: ".8rem" }}>La tua media:</h5>
                                <CircularProgressbarWithChildren 
                                    value={ average * 10 } 
                                    strokeWidth={ 5 }
                                    styles={ buildStyles({
                                        pathColor: isNaN(average) ? "rgb(102, 101, 101)" : average >= 6 ? '#00e4136e' : average >= 5.5 ? "rgb(255, 166, 0)" : "rgb(255, 0, 0)",
                                        trailColor: 'rgb(102, 101, 101)',
                                        textColor: "white",
                                    }) }>
                                        <h4 style={{ textAlign: "center", fontSize: "2rem" }} onClick={ () => setPage({ page: "grades" }) }>{ isNaN(average) ? "?" : Number(average).toFixed(1) }</h4>
                                </CircularProgressbarWithChildren>
                            </div>
                            <div style={{ flex: "1", marginLeft: "1rem" }}>
                                <h5 style={{ marginTop: "0",  textAlign: "center", fontSize: ".8rem"}}>Ultimo voto:</h5>
                                <CircularProgressbarWithChildren
                                    value={ lastGrade?.grades?.[user?.id]?.grade * 10 } 
                                    strokeWidth={ 5 }
                                    styles={ buildStyles({
                                        pathColor: isNaN(average) ? "rgb(102, 101, 101)" : lastGrade?.grades?.[user?.id]?.grade >= 6 ? '#00e4136e' : lastGrade?.grades?.[user?.id]?.grade >= 5.5 ? "rgb(255, 166, 0)" : "rgb(255, 0, 0)",
                                        trailColor: 'rgb(102, 101, 101)',
                                        textColor: "white",
                                    }) }>
                                        { isNaN(average) ? <h4 style={{ textAlign: "center", fontSize: "2rem" }}>?</h4> : 
                                            <>
                                                <h4 onClick={ () => setPage({ page: "add", event: lastGrade }) } style={{ marginTop: "1rem", marginBottom: "0",  textAlign: "center", fontSize: "2rem" }} >{ literalGrades[numericGrades.indexOf(lastGrade?.grades?.[user?.id]?.grade)] }</h4>
                                                <h5 onClick={ () => setPage({ page: "add", event: lastGrade }) } style={{ marginTop: ".25rem",  textAlign: "center", fontSize: ".8rem" }}>{ lastGrade?.subject }</h5>
                                        </> }
                                </CircularProgressbarWithChildren>
                            </div>
                        </div>
                        <div className={ style.gradesLegend }>
                            <div className={ style.flex } style={{ marginTop: ".5rem", paddingBottom: ".5rem", marginLeft: "auto", marginRight: "0" }} onClick={ () => setPage({ page: "grades" }) }>
                                <h4 className={ style.quickLink }>Vedi tutti i voti</h4>
                                <img src={ icons.arrow_right_icon } style={{ height: "1.5rem", marginTop: "0", marginBottom: "0", display: "block" }}></img>
                            </div>
                        </div>
                    </section>
                </section>;
            case "timetable":
                return <section key="timetable" onTouchStart={ e => {
                    sectionsTouchInterval = setInterval(() => setEditingSectionsOrder(true), 500)
                    e.stopPropagation();
                } } onTouchMove={ () => clearInterval(sectionsTouchInterval) } onTouchEnd={ () => clearInterval(sectionsTouchInterval) } className={ [style.pageSection, editingSectionsOrder && style.editingSectionsOrder].join(" ") }>
                    <div className={ style.flex } >
                        <h3 className={ style.sectionHeader } >Il tuo orario</h3> 
                        { editingSectionsOrder && <div className={ style.editSectionOrder }>
                            <img src={ icons.arrow_up_icon } style={{ width: "2rem", height: "2rem" }} onClick={ e => {
                                e.stopPropagation();
                                moveSection(section, true)
                            } }></img>
                            <img src={ icons.arrow_down_icon } style={{ width: "2rem", height: "2rem" }} onClick={ e => {
                                e.stopPropagation();
                                moveSection(section, false);
                            } }></img>
                        </div> }
                    </div>
                    <div className={ style.daySelect }>
                        { getWeekDays().map((weekDay, index) => <div key={ `weekDay-${weekDay.getDay()}` } className={ [style.dayOption, date.getDate() === weekDay.getDate() && style.selected].join(" ") } onClick={ () => setSwiperActiveSlide(index) }>
                            <h4 className={ style.dayOptionWeekDay }>{ getItalianWeekDay(weekDay.getDay())[0] }</h4>
                            <h4 className={ style.dayOptionDate }>{ weekDay.getDate() }</h4>
                        </div>) }
                    </div>
                    <Swiper ref={ swiper } onSlideChange={ ({ activeIndex }) => setSwiperActiveSlide(activeIndex) } autoHeight>
                        { getWeekDays().map((weekDay, index) => {
                            const eventsWithoutLesson = getEventsWithoutLesson(weekDay);
                            return <SwiperSlide key={ `weekDaySlide-${weekDay.getDay()}` }>
                                { (timetable?.[weekDay.getDay()] && Object.keys(timetable?.[weekDay.getDay()]).length > 0) ? <section className={ style.timetable }>
                                    <div className={ style.progress }>
                                        { eventsWithoutLesson.length > 0 && <span key={ `progress-others` } style={{ marginBottom: "4rem" }} className={ [style.classIndicator, style.last, !eventsWithoutLesson.find(event => !event.done?.[user.id]) && style.done].join(" ") }>
                                            { !eventsWithoutLesson.find(event => !event.done?.[user.id]) && <img src={ icons.check_icon }></img> }
                                        </span> }
                                        { Object.keys(timetable[weekDay.getDay()]).map((startTime, index) => {
                                            const lastElement = Object.keys(timetable[weekDay.getDay()]).length - 1 === index;
                                            const [hour, minute] = startTime.split(":");
                                            
                                            const lessonDate = new Date(weekDay);
                                            lessonDate.setUTCHours(parseInt(hour));
                                            lessonDate.setUTCMinutes(parseInt(minute));

                                            return <span key={ `progress-${index}` } className={ [style.classIndicator, lastElement && style.last, (new Date()).getTime() > lessonDate.getTime() && style.done].join(" ") }>
                                                { (new Date()).getTime() > lessonDate.getTime() && <img src={ icons.check_icon }></img> }
                                            </span>; 
                                        }) }
                                    </div>
                                    <div className={ style.content }>
                                        { eventsWithoutLesson.length > 0 && <div className={ style.class } onClick={ () => openEvents(weekDay, { startTime: "??:??", endTime: "??:??", subjectTitle: "Altro" }, true) }>
                                            <section className={ style.classHeader }>
                                                <img className={ style.subjectIcon } src={ icons.question_mark_orange_icon }></img>
                                                <h4 className={ style.subject }>Altro</h4>
                                            </section>
                                            <section className={ style.classBottom }>
                                                <h3 className={ style.eventsCount }><span>{ eventsWithoutLesson.length }</span> eventi</h3>
                                                <img src={ icons.clock_orange_icon }></img>
                                                <h5 className={ style.time }>??:?? - ??:??</h5>
                                            </section>
                                        </div> }
                                        { Object.values(timetable[weekDay.getDay()]).map((lesson, index) => {
                                            const replacementEvent = getReplacementEvents(weekDay)[lesson.startTime];
                                            return <div key={ `lesson-${index}` } className={ style.class } onClick={ () => openEvents(weekDay, lesson) }>
                                                <section className={ style.classHeader }>
                                                    <img className={ style.subjectIcon } src={ icons[getSubjectIcon(replacementEvent?.subject ?? lesson.subjectTitle)] }></img>
                                                    <h4 className={ style.subject }>{ replacementEvent?.subject ?? lesson.subjectTitle }</h4>
                                                </section>
                                                <section className={ style.classBottom }>
                                                    <h3 className={ style.eventsCount }><span>{ replacementEvent ? 1 : getLessonEvents(weekDay, lesson).length }</span> eventi</h3>
                                                    <img src={ icons.clock_orange_icon }></img>
                                                    <h5 className={ style.time }>{ lesson.startTime } - { lesson.endTime }</h5>
                                                </section>
                                            </div>
                                        }) }
                                    </div>
                                </section> :
                                <div className={ style.noTimetable }>
                                    { (subjects && Object.keys(subjects).length > 0) ? <>
                                        <h3 className={ style.noTimetableHeader }>Non hai nessuna lezione!</h3>
                                        <IconButton text="VAI ALL'ORARIO" icon={ icons.clock_icon } style={{ marginTop: "2rem", padding: ".5rem 0", marginBottom: "2rem" }} onClick={ () => setPage({ page: "menu", menuPage: "timetable", from: "home", timetableDay: index }) } />
                                    </> : 
                                    <>
                                        <h3 className={ style.noTimetableHeader }>Non hai nessuna lezione!</h3>
                                        <IconButton text="VAI ALLE MATERIE" icon={ icons.sync_icon } style={{ marginTop: "2rem", padding: ".5rem 0", marginBottom: "2rem" }} onClick={ () => setPage({ page: "menu", menuPage: "subjects", from: "home" }) } />                
                                    </> }
                                </div> }
                            </SwiperSlide>
                        }) }
                    </Swiper>
                </section>;
            case "events":
                if (getUpcomingEvents().length === 0)
                    return <></>;
                    
                return <section key="events" onTouchStart={ e => {
                    sectionsTouchInterval = setInterval(() => setEditingSectionsOrder(true), 500)
                    e.stopPropagation();
                } }  onTouchMove={ () => clearInterval(sectionsTouchInterval) } onTouchEnd={ () => clearInterval(sectionsTouchInterval) } className={ [style.pageSection, editingSectionsOrder && style.editingSectionsOrder].join(" ") }>
                    <div className={ style.flex } >
                        <h3 className={ style.sectionHeader }>Prossimi eventi</h3>
                        { editingSectionsOrder && <div className={ style.editSectionOrder }>
                            <img src={ icons.arrow_up_icon } style={{ width: "2rem", height: "2rem" }} onClick={ e => {
                                e.stopPropagation();
                                moveSection(section, true);
                            } }></img>
                            <img src={ icons.arrow_down_icon } style={{ width: "2rem", height: "2rem" }} onClick={ e => {
                                e.stopPropagation();
                                moveSection(section, false);
                            } }></img>
                        </div> }
                    </div>
                    <div className={ style.nextEvents }>
                        <Swiper slidesPerView={ getUpcomingEvents().length > 1 ? 1.2 : 1 }>
                            { getUpcomingEvents().map(event => <SwiperSlide key={ event.id }>
                                <div className={ style.event }>
                                    <div className={ style.flex } style={{ marginBottom: "1rem" }} onClick={ e => {
                                        e.stopPropagation();
                                        setPage({ page: "add", event });
                                    } }>
                                        <img src={ icons.clock_orange_icon }></img>
                                        <h3>{ dateFormatter.format(new Date(event.date ?? event.startDate))[0].toUpperCase() + dateFormatter.format(new Date(event.date ?? event.startDate)).slice(1) }</h3>
                                    </div>
                                    <div className={ style.flex }>
                                        <img src={ icons[getSubjectIcon(event.subject)] } style={{  marginTop: "auto", marginBottom: "auto", }} onClick={ e => {
                                            e.stopPropagation();
                                            setPage({ page: "add", event });
                                        } }></img>
                                        <div style={{ marginLeft: ".5rem", flex: "1" }} onClick={ e => {
                                            e.stopPropagation();
                                            setPage({ page: "add", event });
                                        } }>
                                            <h4>{ event.subject }</h4>
                                            <h5>{ getItalianType(event.type) }</h5>
                                        </div>
                                        <Checkbox onClick={ e => e.stopPropagation() } checked={ event.done?.[user?.id] } onChange={ e => setChecked(event, e.target.checked) } id={ event.id } style={{ marginTop: ".5rem", zIndex: "100"  }} />
                                    </div>
                                </div>
                            </SwiperSlide>) }
                        </Swiper>
                    </div>
                </section>;
        }
    };

    if (props.loading)
        return <main className={ style.main } style={{ height: "100%" }}>
            <h3 className={ style.sectionHeader } style={{ marginBottom: "0" }}>I tuoi voti</h3>       
            <section className={ [style.progessStatus, style.loading].join(" yy") } style={{ maxWidth: "100vw", paddingTop: "0" }}>
                <div className={ style.flex } style={{ padding: "1rem" }}>
                    <div style={{ flex: "1", marginRight: "1rem", marginTop: "-1rem" }}>
                        <h5 style={{ marginTop: "0",  textAlign: "center", fontSize: ".8rem" }}> </h5>
                        <CircularProgressbar 
                            value={ 65 } 
                            strokeWidth={ 5 }
                            styles={ buildStyles({
                                pathColor: "rgb(133, 132, 132)",
                                trailColor: 'rgb(102, 101, 101)',
                            }) } />
                    </div>
                    <div style={{ flex: "1", marginLeft: "1rem", marginTop: "-1rem" }}>
                        <h5 style={{ marginTop: "0",  textAlign: "center", fontSize: ".8rem"}}> </h5>
                        <CircularProgressbar
                            value={ 80 } 
                            strokeWidth={ 5 }
                            styles={ buildStyles({
                                pathColor: "rgb(133, 132, 132)",
                                trailColor: 'rgb(102, 101, 101)',
                            }) } />
                    </div>
                </div>
            </section>
            <h3 className={ style.sectionHeader }>Il tuo orario</h3>
            <div className={ style.daySelect }>
                { getWeekDays().map((weekDay, index) => <div key={ `weekDay-loading-${weekDay.getDay()}` } className={ [style.dayOption, date.getDate() === weekDay.getDate() && style.selected].join(" ") } onClick={ () => setSwiperActiveSlide(index) }>
                    <h4 className={ style.dayOptionWeekDay }>{ getItalianWeekDay(weekDay.getDay())[0] }</h4>
                    <h4 className={ style.dayOptionDate }>{ weekDay.getDate() }</h4>
                </div>) }
            </div>
            <Swiper ref={ swiper } onSlideChange={ ({ activeIndex }) => setSwiperActiveSlide(activeIndex) }>
                { getWeekDays().map((weekDay, index) => {
                    return <SwiperSlide key={ `weekDaySlide-loading-${weekDay.getDay()}` }>
                        <section className={ style.timetable }>
                            <div className={ style.progress }>
                                { [0, 1, 2].map(val => <span key={ `progress-loading-${val}` } className={ [style.classIndicator, val === 2 && style.last].join(" ") }></span>) }
                            </div>
                            <div className={ style.content }>
                                { [0, 1, 2].map((_, index) => {
                                    return <div key={ `lesson-loading-${index}` } className={ [style.class, style.loading].join(" ") }>
                                        <section className={ style.classHeader }>
                                            <img className={ style.subjectIcon } src={ icons.question_mark_orange_icon }></img>
                                            <h4 className={ style.subject }>{ "..." }</h4>
                                        </section>
                                        <section className={ style.classBottom }>
                                            <h3 className={ style.eventsCount }><span>?</span> eventi</h3>
                                            <img src={ icons.clock_orange_icon }></img>
                                            <h5 className={ style.time }>??:?? - ??:??</h5>
                                        </section>
                                    </div>
                                }) }
                            </div>
                        </section>
                    </SwiperSlide>
                }) }
            </Swiper>
            <div className={ style.flex } >
                <h3 className={ style.sectionHeader }>Prossimi eventi</h3>
            </div>
            <div className={ style.nextEvents }>
                <Swiper slidesPerView={ 1.2 }>
                    <SwiperSlide>
                        <div className={ [style.event, style.loading].join(" ") }>
                            <div className={ style.flex } style={{ marginBottom: "1rem" }}>
                                <img src={ icons.clock_orange_icon }></img>
                                <h3>Oggi</h3>
                            </div>
                            <div className={ style.flex }>
                                <img src={ icons.italian_icon } style={{  marginTop: "auto", marginBottom: "auto", }}></img>
                                <div style={{ marginLeft: ".5rem", flex: "1" }}>
                                    <h4>Italiano</h4>
                                    <h5>Verifica</h5>
                                </div>
                            </div>
                        </div>
                    </SwiperSlide>
                    <SwiperSlide>
                        <div className={ [style.event, style.loading].join(" ") }>
                            <div className={ style.flex } style={{ marginBottom: "1rem" }}>
                                <img src={ icons.clock_orange_icon }></img>
                                <h3>Oggi</h3>
                            </div>
                            <div className={ style.flex }>
                                <img src={ icons.italian_icon } style={{  marginTop: "auto", marginBottom: "auto", }}></img>
                                <div style={{ marginLeft: ".5rem", flex: "1" }}>
                                    <h4>Italiano</h4>
                                    <h5>Verifica</h5>
                                </div>
                            </div>
                        </div>
                    </SwiperSlide>
                </Swiper>
            </div>
        </main>;

    return <main className={ style.main } ref={ main } style={{ height: selected !== null ? "100vh" : "100%" }} onClick={ e => {
        setEditingSectionsOrder(false);
    } }>
        <Banner />
        <Reorder.Group axis="y" values={ sectionsOrder.today } onReorder={ newOrder => {
            localStorage.setItem("globalSectionsOrder", JSON.stringify({ ...sectionsOrder, today: newOrder }))
            setSectionsOrder({ today: newOrder });
        } } style={{ listStyleType: "none", padding: "0", margin: "0" }}>
            { sectionsOrder.today.map((section) => <Reorder.Item key={ section } value={ section } dragListener={ editingSectionsOrder }>{ getPageSection(section) }</Reorder.Item>) }
        </Reorder.Group>
        <Events
            mainContent={ props.mainContent } 
            selected={ selected }
            lesson={ getReplacementEvents(date)?.[selected?.startTime] ? { ...selected, subjectTitle: getReplacementEvents(date)?.[selected?.startTime].subject, icon: getSubjectIcon(getReplacementEvents(date)?.[selected?.startTime]?.subject) } : selected }
            date={ date }
            events={ selected?.subjectTitle === "Altro" ? getEventsWithoutLesson(date) : getReplacementEvents(date)?.[selected?.startTime] ? [getReplacementEvents(date)?.[selected?.startTime]] : getLessonEvents(date, selected) }
            hide={ e => {
                e.stopPropagation();
                setSelected(null);
            } } 
        />
    </main>;
};

export default Today;
